import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from '@shared/components/modal/modal.module';
import { MostUsedModule } from '@shared/components/most-used/most-used.module';
import { ResetPasswordComponent } from './reset-password.component';



@NgModule({
  declarations: [
    ResetPasswordComponent
  ],
  exports: [
    ResetPasswordComponent
  ],
  imports: [
    CommonModule,
    ClipboardModule,
    MostUsedModule,
    ModalModule
  ]
})
export class ResetPasswordModule { }
